export default __webpack_public_path__ + "static/media/Emojis13.197d9733.png";